import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function SuccessPage() {
    const navigate = useNavigate()
    useEffect(() => {
        setTimeout(() => {
            navigate('/DcmTimeTable')
        }, 2000)
    }, [])
    return (
        <div className="TotalContainer d-md-flex">
            <div className="banner_box col-lg-3 col-md-5 col-12 m-0 p-0">
                <img
                    className="banner_img "
                    src="/Register-img/baner_img.jpg"
                    alt="banner img"
                ></img>
            </div>
            <div className="successDiv">
                <img
                    className=""
                    src="/Register-img/succes_login.svg"
                    alt="banner img"
                ></img>
            </div>
        </div>
    )
}

export default SuccessPage;
